import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { routes } from 'routes/routes'
import { ArticleType, LessonTimelineItem } from 'types'
import { getRoute } from 'utils'
import { TimelineItemCard } from '../TimelineItemCard/TimelineItemCard'

export function TimelineLessonItem({ item }: { item: LessonTimelineItem }) {
  const navigate = useNavigate()

  const onClickArticle = () => {
    const route = getRoute(routes.journeyItem, {
      journeyItemType: ArticleType.Lesson,
      journeyItemId: item.lessonId,
    })
    navigate(route)
  }

  return (
    <TimelineItemCard
      title={item.lesson.post || item.lesson.name}
      bannerUrl={item.lesson.bannerUrl}
      status={item.status}
      readingTime={item.lesson.silentReadingTime}
      onClick={onClickArticle}
      controls={
        <Button size="small" variant="contained" onClick={onClickArticle}>
          View
        </Button>
      }
    />
  )
}
